function extractionOptionsErrorCheck({ extractionConfig, hybridRegions }) {
  const error = [];
  if (extractionConfig && extractionConfig.hybrid && hybridRegions && extractionConfig.siwave && !extractionConfig.siwave.suggestHFSSRegions) {
    if (!hybridRegions.length) {
      error.push("[Extraction Options] No zone definitions, please set zone.")
    } else if (!hybridRegions.find(item => item.extraction === "HFSS")) {
      error.push('[Extraction Options] Zone definitions must have at least one zone set to "HFSS"')
    }
  }

  return error;
}

export {
  extractionOptionsErrorCheck
};